var url = window.location.href;
let openedCategoryTriggered = false;
const searchParams = new URLSearchParams(window.location.search);
const openedCategory = searchParams.get("openedCategory");
const sceneCode = searchParams.get("code");
var sceneFullyLoadedOccurred = false;
if (url.indexOf("autoload") == -1) {
  //jQuery('#wrap').css('display', 'block');
}
if (url.indexOf("autoload") > 1) {
  //autoload fo scenes in mobile
  //jQuery('#wrap').css('display', 'none');
  jQuery("body").prepend('<div class="auto-load"></div>');
  var intervalId = window.setInterval(function () {
    var len = jQuery("#xpv-toolbar-item-web-ar").length;
    if (
      len == 1 &&
      jQuery("#xpv__viewer_load_backdrop").css("display") == "none"
    ) {
      jQuery("#xpv-toolbar-item-web-ar").click();
      jQuery(".auto-load").css("display", "none");
      clearInterval(intervalId);
    }
  }, 500);
  setTimeout(get_length, 200);
}

jQuery(document).ready(function ($) {
  waitForEl(".catalogue-button", function () {
    if (openedCategory) {
      jQuery(".catalogue-button").trigger("click");
      jQuery(".expivi-options-wrapper").trigger("mouseover");
      jQuery("body").addClass("catalog-opened");
      jQuery(
        ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4) .catalogue"
      ).show();
    }
  });
  if (openedCategory) {
    const categoryToLowerCase = openedCategory.toLowerCase();
    const categoryFormatted =
      categoryToLowerCase.charAt(0).toUpperCase() +
      categoryToLowerCase.slice(1);
    waitForEl("h2:contains(" + categoryFormatted + ")", function () {
      if (openedCategory) {
        jQuery("h2:contains(" + categoryFormatted + ")").trigger("click");
        openedCategoryTriggered = true;
      }
    });
  }

  // Function to replace AR button content with custom SVG icon and text
  function replaceArButtonContent() {
    waitForEl("#xpv-toolbar-item-web-ar", function () {
      var arButton = jQuery("#xpv-toolbar-item-web-ar");
      if (arButton.length && !arButton.hasClass("custom-ar-styled")) {
        arButton.addClass("custom-ar-styled");
        arButton.html(
          '<img src="https://cdn.shopify.com/s/files/1/0683/4074/4392/files/ar_mobile_no_text.svg?v=1753388780" alt="AR Icon" style="width: 30px; vertical-align: middle;"><p>VIEW IN MY ROOM</p>'
        );
      }
    });
  }

  // Call the function to replace AR button content
  replaceArButtonContent();

  isMobile = false;
  // device detection
  if (
    /Android|webOS|Mobile|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) ||
    (navigator.platform === "MacIntel" &&
      navigator.maxTouchPoints > 1 &&
      !window.MSStream)
  ) {
    var isMobile = true;
  }

  if (isMobile == false) {
    jQuery(".expivi-button").css("display", "inline-block");
    jQuery("body").addClass("not-mobile");
  } else {
    jQuery("body").addClass("is-mobile");
  }
  if (jQuery("#admin-menu").length) {
    jQuery("body").addClass("admin-menu");
  }

  jQuery(".catalogue-button").unbind("click");
  jQuery("body").on("click", ".catalogue-button", function () {
    if (jQuery("body").hasClass("not-logged-in")) {
      jQuery(".menu-sign-in > span").click();
      jQuery(".sign-in-title > span").hide();
      jQuery(".sign-in-title").append("<span> to create a scene</span>");
    } else {
      jQuery("body").toggleClass("catalog-opened");
      if (jQuery("body").hasClass("catalog-opened")) {
        jQuery(
          ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4)"
        ).show();
        jQuery(
          ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4) .catalogue"
        ).show();
        if (!jQuery("#categoryProducts").length) {
          jQuery(".catalogue-button").after(
            '<div class="ar-product-search"><span class="icon-search" aria-hidden="true"></span><input type="text" id="categoryProducts" placeholder="Search for AR products" autocomplete="off"/><span class="ar-product-search-close"><button type="button" id="cboxClose" class="cbox-close-plain"><span class="icon-close"></span></button></span></div>'
          );
        }
        jQuery(".ar-product-search").show();
        jQuery(".ar-search-catalogue").hide();
        jQuery(".overflow-y-auto.overflow-x-hidden.mt-2.pa-1").show();
      } else {
        jQuery(
          ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4) .catalogue"
        ).hide();
        jQuery(".ar-product-search").hide();
        filterValue = undefined;
        jQuery("#categoryProducts").val("");
      }
      jQuery(
        ".expivi-options-wrapper .v-application .theme--light.v-sheet--outlined.rounded"
      ).removeClass("opened");
      jQuery(
        ".node-type-ar .expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden"
      ).css("padding-bottom", "0");
      jQuery(
        ".node-type-ar .expivi-options-wrapper .theme--light.v-application .row"
      ).css({
        position: "relative",
        bottom: "auto",
      });

      var products_count = jQuery(
        ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(3) > .row"
      ).length;
      if (products_count > 2) {
        //more than one product added to scene (there is 1 additional div there)
        jQuery("body").addClass("more-products");
        jQuery("body").removeClass("first-load");
        jQuery(
          ".expivi-options-wrapper .v-application .theme--light.v-sheet--outlined.rounded"
        ).removeClass("opened");
      } else {
        jQuery("body").removeClass("more-products");
      }
      if (jQuery(window).width() <= 1023) {
        if (jQuery("body").hasClass("catalog-opened")) {
          jQuery("html, body").animate(
            {
              scrollTop: jQuery(".catalogue-button").offset().top + 100,
            },
            500
          );
        }
      }
      jQuery(".scroll-info").addClass("hidden");
      jQuery(
        ".catalog-opened .expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4) .loading"
      ).show();
      if (openedCategoryTriggered) {
        //check if function with URL opened category was triggered once
        jQuery(
          ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4)"
        ).hide();
        openedCategoryTriggered = false;
      }
      waitForEl("#categoryProducts", async function () {
        let searchResultsRow = jQuery(
          '<div class="catalogue ar-search-catalogue" style="display: block;"><div><div class="row" style="position: relative; bottom: auto;"><div class="category-title col search-results-title"><h2>Search results</h2></div></div><div class="row open ar-product-search-results" style="position: relative; bottom: auto;"></div></div>'
        );
        let draggableItem, productDataVAttribute;
        let catalogueProducts = await expivi.getCatalogueProducts(0, 500);
        jQuery("#categoryProducts").one("input", async function () {
          // if (!jQuery('.xpv-app-container').hasClass('ar-search-catalogue')) {
          if (!jQuery("body").hasClass("ar-search-added")) {
            jQuery(".mt-2").before(searchResultsRow);
            jQuery("body").addClass("ar-search-added");
          }

          draggableItem = await jQuery(".draggable-item").first().data();
          productDataVAttribute = `data-${Object.keys(draggableItem).filter(
            (k) => k.startsWith("v-")
          )}`;
        });

        jQuery("#categoryProducts").on("input", async function () {
          var filterValue = jQuery(this).val().toLowerCase();
          var filteredProducts;

          if (filterValue.length) {
            jQuery(".ar-search-catalogue").show();
            jQuery(".ar-product-search-results").show();
            if (!jQuery("body").hasClass("ar-search-added")) {
              jQuery(
                ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4)"
              ).prepend(
                '<div class="loading"><img src="https://cdn.shopify.com/s/files/1/0683/4074/4392/files/loader4.gif?v=1753388081" /><br/></div>'
              ); //add loading icon
            }
            jQuery(".search-results-title").show();
            if (filterValue.length > 1 && catalogueProducts) {
              filteredProducts = catalogueProducts.filter((product) =>
                product.name.toLowerCase().includes(filterValue)
              );
              jQuery(".ar-product-search-results").empty();
              if (filteredProducts.length) {
                filteredProducts.forEach((product) => {
                  let draggableItem = createDraggableItem(
                    product,
                    productDataVAttribute
                  );
                  jQuery(".ar-product-search-results").append(draggableItem);
                });
              } else {
                jQuery(".ar-product-search-results").prepend(
                  '<div class="no-results">No products found.</div>'
                );
              }
              jQuery(".overflow-y-auto.overflow-x-hidden.mt-2.pa-1").attr(
                "style",
                "display: none !important"
              );
            }
          } else {
            filterValue = undefined;
            filteredProducts = [];
            jQuery(".ar-product-search-results").hide();
            jQuery(".search-results-title").hide();
            jQuery(".overflow-y-auto.overflow-x-hidden.mt-2.pa-1").show();
          }
        });
        jQuery(".ar-product-search-close > #cboxClose.cbox-close-plain").on(
          "click",
          function () {
            jQuery("#categoryProducts").val("");
            jQuery(".ar-search-catalogue").hide();
            filterValue = undefined;
            filteredProducts = [];
            jQuery(".overflow-y-auto.overflow-x-hidden.mt-2.pa-1").show();
          }
        );
        // Hide Not Categorized category
        jQuery(".category-title h2").last().hide();
      });
    }
  });

  jQuery("body").on(
    "click",
    ".expivi-options-wrapper .flex-grow-0.col > span",
    function () {
      if (jQuery(this).find("svg")) {
        jQuery("body").removeClass("catalog-opened");
      }
    }
  );

  jQuery("#viewerExpiviContainer").on("click", function () {
    jQuery("body").removeClass("catalog-opened").removeClass("more-products");
    jQuery(
      ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4)"
    ).hide();
    jQuery(".ar-product-search").hide();
    // show product attributes when product selected in viewer
    onSelected(window.expivi.viewer.mSelectedProduct);
  });

  // show popup if AR planner not loaded after a minute
  let sceneTimeout = setTimeout(function () {
    if (
      !sceneFullyLoadedOccurred &&
      jQuery("body").hasClass("page-ar-scene") &&
      (sceneCode || jQuery("body").hasClass("logged-in")) &&
      jQuery("h1.page-header").text() != "Access denied"
    ) {
      jQuery("body").prepend(getModalWindow());
    }
  }, 180000);

  jQuery("body").on("click", "#close-modal-window", function () {
    jQuery("#scene-modal-window").hide();
    jQuery("#scene-modal-window + .blackout-header").hide();
    clearTimeout(sceneTimeout);
  });

  jQuery.fn.reverse = function (fn) {
    var i = this.length;

    while (i--) {
      fn.call(this[i], i, this[i]);
    }
  };
  jQuery(".node-type-ar").addClass("first-load");

  waitForEl(".v-card__text.delete", function () {
    jQuery(".v-card__text.delete").eq(0).hide();
  });

  onElementInserted("body", ".v-card__text.delete", function (e) {
    jQuery(".v-card__text.delete").each(function () {
      let prev = jQuery(this).prev();
      if (!prev.hasClass("copy")) {
        jQuery(this).before('<div class="v-card__text copy">Duplicate</div>');
      }
    });
  });

  onElementInserted("body", ".v-card__text.copy", function () {
    jQuery(".v-card__text.copy").unbind("click");
    jQuery(".v-card__text.copy").on("click", async function (e) {
      if (e.target !== this) return;
      let product_uid = jQuery(this).closest(".scene-item").data("xpv-uuid");
      copyProduct(product_uid);
    });
  });
  onElementInserted("body", ".r-cart-items", function () {
    if (!jQuery(".r-cart-empty").length > 0) {
      jQuery(".r-cart-buttons").append(
        '<a href="#" id="clear-cart" class="btn justify-center r-cart-clear">Clear Cart</a>'
      );
    }
  });

  jQuery(window).keypress(function (event) {
    if (event.shiftKey && event.which == 68) {
      let product_uid =
        jQuery(".v-card.v-card--link.opened").data("product-uuid") ||
        jQuery(".v-card.v-card--link.select-disabled").data("product-uuid");
      copyProduct(product_uid);
    }
  });

  //show attributes UNDER the clicked product in DISPLAYED PRODUCTS list
  jQuery(
    ".expivi-options-wrapper .v-application .theme--light.v-sheet--outlined.rounded"
  ).unbind("click");
  jQuery("body").on(
    "click",
    ".expivi-options-wrapper .v-application .theme--light.v-sheet--outlined.rounded",
    function () {
      // if(!jQuery('body').hasClass('clicked-product')) {
      var parent = jQuery(this).parent().parent();
      var top1 = jQuery(
        ".expivi-options-wrapper .x-p-v>.container>div>div:last-child"
      ).position().top;
      var top2 = jQuery(parent).position().top;
      if (
        top1 - top2 < 180 &&
        top1 - top2 > 0 &&
        jQuery(
          ".expivi-options-wrapper .x-p-v>.container>div>div:last-child"
        ).css("display") !== "none"
      ) {
        jQuery(this).removeClass("opened");
        jQuery(this).addClass("select-disabled");
        jQuery(
          ".expivi-options-wrapper .x-p-v>.container>div>div:last-child"
        ).css("display", "none");
        parent.css({ position: "relative", bottom: "auto" });
        parent
          .siblings()
          .css({ position: "relative", bottom: "auto" })
          .removeClass("opened");
        jQuery(
          ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden"
        ).css("padding-bottom", "0");
      } else {
        productSelect(jQuery(this));
        if (jQuery(this).hasClass("select-disabled")) {
          jQuery(this).removeClass("select-disabled");
        }
      }
      //   }
    }
  );

  jQuery(".expivi-options-wrapper").on("mouseover", function () {
    var products = jQuery(
      ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4) .v-card .v-image"
    );
    var count_products = products.length;
    var count_tooltips = jQuery(
      ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4) .tooltip-text"
    ).length;
    if (count_products !== 0 && count_products !== count_tooltips) {
      products.each(function () {
        if (jQuery(this).find(".tooltip-text").length == 0) {
          jQuery(this).append('<div class="tooltip-text">Drag & Drop</div>');
        }
      });
    }

    if (
      !$("body").hasClass("one-product-reloaded") &&
      $(".node-type-ar .expivi-options-wrapper").find(
        ".row.scene-item .v-card--link"
      ).length > 0
    ) {
      $(".node-type-ar .expivi-options-wrapper")
        .find(".row.scene-item .v-card--link")
        .click();
      $("body").addClass("one-product-reloaded");
    }
  });

  jQuery(".expivi-options-wrapper").on("mouseover tap", function () {
    //working with catalogue list
    if (
      !jQuery("body").hasClass("catalog-loaded") &&
      jQuery(
        ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4)"
      ).length > 0
    ) {
      // if (jQuery('.expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4) .loading').length == 0) {
      // jQuery('.expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4)').prepend('<div class="loading"><img src="https://cdn.shopify.com/s/files/1/0683/4074/4392/files/loader4.gif?v=1753388081" /><br/></div>') //add loading icon
      // }
      jQuery("body").addClass("catalog-loaded");
      // jQuery('.expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4) .catalogue').show();

      // setTimeout(function () {
      //     jQuery('.expivi-options-wrapper').find('.row.ma-0.mb-1.pa-1 .v-btn--has-bg').each(function (index) {
      //         var that = this;
      //         var t = setTimeout(function () {
      //             // jQuery(that).click();
      //         }, 1000 * index);
      //     });

      //     setTimeout(function () {
      //         jQuery('.expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4) .catalogue').show();
      //         jQuery('.expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(4) .loading').remove();
      //         jQuery('.category-title h2').each(function() {
      //             var title = $(this).html();
      //             if(title == 'Sleeper Sofas' && $('.nav-country-icon').hasClass('ca-icon')) {
      //                 $(this).parent().parent().hide();
      //             }
      //         })

      //         }, 1000);

      // }, 3000);
    }
  });

  jQuery("#menu-login-block").prepend(
    '<p class="sign-in-title"><strong>Sign in</strong> or <strong>create an account</strong></p>'
  );
  jQuery("#menu-login-block").append(
    '<span class="menu-sign-in menu-sign-in-close"></span>'
  );

  jQuery(".menu-sign-in").on("click", function () {
    jQuery("body").toggleClass("log-in-opened");
    jQuery(".blackout").remove();
    jQuery(".sign-in-title > span").hide();
    jQuery(".r-menu-info, #r-menu-cart").removeClass("open");
    $("ul.secondary li:not(.menu-search)").removeClass("activated");
    jQuery("#header").removeClass("open").removeClass("cart-open");
  });
  $(".menu-trigger-ar").click(function () {
    $("#header").toggleClass("open");
    if ($("#header").hasClass("open") && $(".blackout").length == 0) {
      $("#header").after('<div class="blackout"></div>');
    } else if (!jQuery("#header").hasClass("open")) {
      $(".blackout").remove();
    }
    $("body").removeClass("log-in-opened");
    jQuery(".r-menu-info").removeClass("open");
  });

  jQuery(".menu-cart .menu-trigger").on("click", function () {
    jQuery(".r-menu-info").removeClass("open");
    jQuery(".cart-close").unbind("click");
    jQuery(".cart-close").on("click", function () {
      jQuery(".menu-cart button").click();
    });
  });
  $("li.menu-search").unbind("click");
  $("li.menu-search").on("click", function (e) {
    e.preventDefault();
    $("html").toggleClass("overflow-hidden");
    $("html").toggleClass("overflow-hidden-long");
    //$('#header').toggleClass('show');
    $("#header").toggleClass("search");
    if (!$("#header").hasClass("search")) {
      $("#header").removeClass("show");
      $(".blackout").remove();
    } else if ($(".blackout").length == 0) {
      $("#header").after('<div class="blackout"></div>');
    }
    var val = jQuery(".form-item-title input").val();
    jQuery(".form-item-title input").focus();
    jQuery(".form-item-title input").val("").val(val);
  });

  jQuery(".menu-trigger-ar, .menu-search").on("click", function () {
    jQuery(".r-menu-info, #r-menu-cart").removeClass("open");
    $("ul.secondary li:not(.menu-search)").removeClass("activated");
  });
  jQuery(".menu-ship-to > span").unbind("click");
  $(".menu-ship-to > span").on("click", function () {
    $(".r-menu.secondary li").removeClass("activated");
    $(this).parent().addClass("activated");
    $("html").toggleClass("overflow-hidden");
    $("html").toggleClass("overflow-hidden-long");
    $(this).parent().toggleClass("activated");
    //$('#header').toggleClass('show');
    $("#header").toggleClass("countries-open");
    $(".r-menu-info").removeClass("open");
    jQuery(".r-menu-info, #r-menu-cart").removeClass("open");
    $("ul.secondary li:not(.menu-search)").removeClass("activated");
    jQuery("#header").removeClass("open").removeClass("cart-open");
    if (!$("#header").hasClass("countries-open")) {
      $("#header").removeClass("show");
      $(".blackout").remove();
    } else if ($(".blackout").length == 0) {
      $("#header").after('<div class="blackout"></div>');
    }
  });

  jQuery(".menu-search, .menu-ship-to > span, .menu-my-account").on(
    "click",
    function () {
      jQuery("#header").removeClass("open").removeClass("cart-open");
    }
  );
  jQuery(".menu-my-account .account-text").on("click", function () {
    jQuery("#header").removeClass("open");
  });
  jQuery(".menu-my-account .account-text").on("click", function () {
    jQuery("#header").removeClass("open");
  });

  jQuery(
    ".menu-trigger-ar, .menu-search, .menu-my-account .account-text, .menu-cart .menu-trigger, .menu-sign-in"
  ).on("click", function () {
    jQuery("#header").removeClass("countries-open");
  });

  jQuery(".blackout-header").on("click", function () {
    jQuery("body").removeClass("log-in-opened");
  });

  jQuery(".menu-my-account > span").click(function () {
    if (!jQuery("#header").hasClass("cart-open")) {
      jQuery(".r-menu-info").removeClass("open");
    }
  });
  jQuery(".menu-my-account #cboxClose").unbind("click");
  jQuery(".menu-my-account #cboxClose").on("click", function () {
    jQuery(".menu-my-account  > span:first-child").click();
  });
  jQuery("#nav-menu-ar-primary #cboxClose").on("click", function () {
    jQuery(".menu-trigger-ar").click();
  });

  jQuery(".r-search-reset").on("click", function () {
    jQuery("li.menu-search").click();
    jQuery("#header").removeClass("show").removeClass("search");
    jQuery("body")
      .removeClass("overflow-hidden")
      .removeClass("overflow-hidden-long");
  });

  jQuery("#nav-menu-search").bind("DOMSubtreeModified", function () {
    //var val = jQuery(".form-item-title input").val();
    //jQuery(".form-item-title input").focus();
    //jQuery(".form-item-title input").val('').val(val);
    jQuery(".r-search-reset").on("click", function () {
      jQuery("li.menu-search").click();
      jQuery("#header").removeClass("show").removeClass("search");
      jQuery("html")
        .removeClass("overflow-hidden")
        .removeClass("overflow-hidden-long");
      $("body").find(".blackout").remove();
    });
  });

  $(
    "ul.secondary .menu-search, ul.secondary > li > span, ul.secondary > li > button, .menu-trigger-ar"
  ).on("click", function () {
    $(".blackout").on("click", function () {
      jQuery("body").removeClass("log-in-opened");
      jQuery("#header")
        .removeClass("countries-open")
        .removeClass("open")
        .removeClass("cart-open")
        .removeClass("search");
      $(".r-menu.secondary li").removeClass("activated");
      $("html").removeClass("overflow-hidden");
      $("html").removeClass("overflow-hidden-long");
      jQuery(".r-menu-info, #r-menu-cart").removeClass("open");
      $("body").find(".blackout").remove();
    });
  });

  $("body").click(function () {
    jQuery("#header").removeClass("search");
    $("body").find(".blackout").remove();
  });

  $("body").on(
    "click",
    "#nav-menu-search .view-content, li.menu-search, .r-search-wrap, .menu-trigger-ar, .r-menu.secondary, .r-menu.r-primary",
    function (event) {
      event.stopPropagation();
    }
  );
  $("#nav-menu-search").unbind("click");

  var count = $("#search-hits .ar-category-item-wrapper").length;
  var width = $(window).width();
  if (count > 6 || (count > 3 && width <= 767)) {
    $("#search_more_results").css("display", "block");
  } else {
    $("#search_more_results").hide();
  }
  $(document).ajaxComplete(function () {
    var count = $("#search-hits .ar-category-item-wrapper").length;
    var width = $(window).width();
    if (count > 6 || (count > 3 && width <= 767)) {
      $("#search_more_results").css("display", "block");
    } else {
      $("#search_more_results").hide();
    }
  });

  $(".edit-scene-name").on("click", function () {
    $(this).hide();
    $(".title-wrapper h1").hide();
    $(".title-wrapper .input-wrapper").show();
  });

  //update scene's title
  $(".title-wrapper a").on("click", function () {
    var title = $(".title-wrapper input").val();
    var uri = window.location.pathname;
    var args = uri.split("/");
    var scene_id = args[3];
    jQuery.ajax({
      method: "POST",
      url: Drupal.settings.basePath + "ar/scene/ajax-title",
      data: { ar_title: title, scene_id: scene_id },
      success: function (response) {
        if (response == "1") {
          $(".title-wrapper h1").html($(".title-wrapper input").val());
        }
        $(".title-wrapper h1").show();
        $(".title-wrapper .input-wrapper").hide();
        $(".edit-scene-name").show();
      },
    });
  });

  //fix issue with Dimentions switcher
  jQuery(".expivi-options-wrapper").on(
    "click",
    ".v-list, .tile-card, .v-input__slot",
    async function () {
      let configuration = await expivi.saveConfiguration(0, 0);
      let attributes = configuration.configured_products[0].attributes;
      let dimen = false;
      attributes.forEach(function (currentValue, index, arr) {
        let val = currentValue.attribute_value_name;
        if (
          currentValue.attribute_name.startsWith("DIMENSIONS") &&
          (val.endsWith("ON") ||
            val.startsWith("DimsON") ||
            val.startsWith("DimensionsON"))
        ) {
          dimen = true;
        }
      });
      if (dimen == true) {
        jQuery(".expivi-options-wrapper")
          .find(".v-input--switch label")
          .each(function () {
            if (
              jQuery(this).html().startsWith("DIMENSIONS") &&
              !jQuery(this)
                .closest(".v-input--switch")
                .hasClass("v-input--is-label-active")
            ) {
              jQuery(this).click();
            }
          });
      }
    }
  );

  //by product(s) from AR product page
  $(".buy-products").on("click", async function () {
    jQuery(".buy-products .loading").show();
    let count_initial = 0;
    let configuration = JSON.stringify(await expivi.saveConfiguration(0, 0));
    if (jQuery(".cartempty div").length == 0) {
      count_initial = parseInt(jQuery(".carticon div").html());
    }
  });
  jQuery(document).on("click", "#clear-cart", async function (e) {
    e.preventDefault();
    jQuery.ajax({
      method: "POST",
      url: Drupal.settings.basePath + "ar/scene/clear-cart",
      success: function (response) {
        jQuery("#r-menu-cart").html(response);
        jQuery(".cartempty").text("0");
        jQuery(".carticon").text("0");
        jQuery(".menu-cart button").click();
      },
      error: function (error) {
        console.error("Error clearing cart:", error);
      },
    });
  });

  jQuery("body").on("click", "#colorbox .cancel-btn", function () {
    jQuery("#colorbox #cboxClose").click();
  });

  $(".used-products").on("click", function () {
    $(this).toggleClass("open");
  });

  jQuery("body").on("click", ".category-title h2", function () {
    jQuery(this)
      .parent()
      .parent()
      .siblings()
      .find(".category-title h2")
      .removeClass("open");
    jQuery(this).parent().parent().next().siblings().removeClass("open");
    jQuery(this).toggleClass("open");
    jQuery(this).parent().parent().next().toggleClass("open");
  });

  jQuery("body").on("click", ".category-title h2", function () {
    if (!$(this).hasClass("clicked")) {
      $(this).addClass("clicked");
      var title = $(this).html();
      $(".v-btn.v-btn--has-bg").each(function () {
        var tl = $(this).find("span span").html();
        if (title == tl) {
          $(this).dblclick();
        }
      });
    }
  });

  jQuery("body").on("click", ".category-title", function () {
    var alpha = [];
    var wrapper = jQuery(this).parent().next();
    var elements = wrapper.find(" > div");

    elements.each(function () {
      var alphaArr = [];

      alphaArr.push($(this).attr("data-title"));
      alphaArr.push($(this));
      alpha.push(alphaArr);
      alpha.sort();
    });

    elements.remove();
    for (var i = 0; i < alpha.length; i++) {
      wrapper.append(alpha[i][1]);
    }
  });

  jQuery(".r-cart-bag").unbind("click");
  jQuery("body").on("click", ".r-cart-bag", function () {
    jQuery(".r-cart-bag .loading").show();
    jQuery("#header").addClass("cart-open");
  });

  jQuery("body").on("mouseover", function () {
    var products_count = jQuery(
      ".node-type-ar .expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden>div:nth-child(3) > .row"
    ).length;
    var html = jQuery(".buy-products").html();
    if (html !== "Add to cart") {
        jQuery(".buy-products").html("Add to cart");
      }
    // if (products_count > 2) {
    //   //more than one product added to scene (there is 1 additional div there)
    //   if (html !== "Purchase scene") {
    //     jQuery(".buy-products").html("Purchase scene");
    //   }
    // } else {
    //   if (html !== "Add to cart") {
    //     jQuery(".buy-products").html("Add to cart");
    //   }
    // }
  });

  //order product under category in alpha order
  jQuery(".category-title").click(function () {
    var alpha = [];
    var wrapper = jQuery(this).parent().next();
    var elements = wrapper.find(" > div");

    elements.each(function () {
      var alphaArr = [];

      alphaArr.push($(this).attr("data-title"));
      alphaArr.push($(this));
      alpha.push(alphaArr);
      alpha.sort();
    });

    elements.remove();
    for (var i = 0; i < alpha.length; i++) {
      wrapper.append(alpha[i][1]);
    }
  });

  jQuery("#menu-login-block form").each(function () {
    jQuery(this).attr("action", window.location.pathname);
  });
  $('.r-menu-info a[href="/user/logout"]').attr(
    "href",
    "/user/logout?destination=" + window.location.pathname
  );

  jQuery(".menu-sign-in-close").on("click", function () {
    jQuery("body").removeClass("log-in-opened");
  });

  jQuery(".sign-in-link, .menu-create-account").on("click", function () {
    jQuery("#header").removeClass("open");
  });

  //save scene

  jQuery("body").on(
    "click",
    ".save-scene:not(.clicked), .back-from-edit",
    async function (e) {
      // Drupal-era save. On Shopify, sections/rn-ar.liquid saves the scene to
      // the Rove API; without Drupal this only took a second screenshot and
      // then threw on Drupal.settings.
      if (typeof Drupal === "undefined") return;
      e.preventDefault();
      var current_element = jQuery(this);
      jQuery(".save-scene").addClass("clicked");
      setInterval(function () {
        jQuery(".save-scene").removeClass("clicked");
      }, 3000); //disable click for 3 seconds after click
      let configuration = JSON.stringify(await expivi.saveConfiguration(0, 0));

      let uri = window.location.pathname;
      let is_edit = uri.indexOf("edit") > 0 ? 1 : 0; //check if it's scene edit page or not
      let is_copy = uri.indexOf("edit") > 0 ? 1 : 0; //check if it's scene copy page or not
      let title = "";
      if (is_edit == 1) {
        title = jQuery("h1.page-header").html(); //title of first product
      } else {
        title = jQuery(".v-card--link .v-card__title").first().html();
        let count = jQuery(".v-card--link .v-card__title").length - 1;
        if (count > 0) {
          title += " + " + count + " other product(s)";
        }
      }
      let args = uri.split("/");
      let scene_id = args[3];
      let t = await window.expivi.getCameraTransform();
      let image = await window.expivi.getScreenshot(
        529,
        342,
        "CUSTOM_CAMERA_POSITION",
        "image/jpeg",
        t
      );
      jQuery.ajax({
        method: "POST",
        url: Drupal.settings.basePath + "ar/scene/ajax",
        data: {
          ar_conf: configuration,
          ar_title: title,
          is_edit: is_edit,
          scene_id: scene_id,
          image: image,
          is_copy: is_copy,
        },
        success: function (response) {
          if (response !== "0") {
            //less then 20 scenes for customer
            if (!jQuery("body").hasClass("logged-in")) {
              jQuery("#user-login-form").attr(
                "action",
                "/ar/scene/" + response + "?first_time=1"
              );
              jQuery("#rove2018-user-register-form").attr(
                "action",
                "/ar/scene/" + response + "?first_time=1"
              );
              jQuery(".menu-sign-in > span").click();
              jQuery(".sign-in-title > span").hide();
              jQuery(".sign-in-title").append(
                "<span> to save your scene</span>"
              );
            } else {
              jQuery(".scene-saved")
                .removeClass("error")
                .html("Scene saved!")
                .show();
              setTimeout(function () {
                jQuery(".scene-saved").hide();
              }, 5000);
              if (!is_edit) {
                jQuery("h1.page-header").html(title);
              }
              jQuery(".link-user-profile").hide();
              jQuery(".my-scenes").css("display", "inline-block");
              jQuery(".my-scenes").attr("href", "/ar/scene/" + response);
            }
          } else {
            jQuery(".scene-saved")
              .addClass("error")
              .html("Scene NOT saved! You reached maximum of 20 scenes saved.")
              .show();
            jQuery(".link-user-profile").show();
          }
          if (current_element.hasClass("back-from-edit")) {
            window.location.replace(current_element.attr("href"));
          }
        },
      });
    }
  );

  //get sharable link
  jQuery(".get-share-link").on("click", function (e) {
    e.preventDefault();
    var uri = window.location.pathname;
    var args = uri.split("/");
    var scene_id = args[3];
    jQuery.ajax({
      method: "POST",
      url: Drupal.settings.basePath + "ar/scene/get/link",
      data: { scene_id: scene_id },
      success: function (response) {
        jQuery("#copyTargetLink").attr(
          "value",
          window.location.origin + "/ar/scene/" + scene_id + "?code=" + response
        );
        copyToClipboardMsg(
          document.getElementById("copyTargetLink"),
          "copySuccessMessage"
        );
        jQuery("#copySuccessMessage").show();
        setInterval(function () {
          jQuery("#copySuccessMessage").hide();
        }, 3000);

        //jQuery('.copy-text').click();
        //jQuery(".sharable-link").show();
      },
    });
  });

  jQuery(".copy-text").on("click", function (e) {
    e.preventDefault();
    copyToClipboardMsg(
      document.getElementById("copyTargetLink"),
      "copySuccessMessage"
    );
  });

  jQuery(".button-instruction").on("click", function (e) {
    e.preventDefault();
    jQuery(".popup-instruction").toggleClass("open");
  });
  if (jQuery("#viewerExpiviContainer").length > 0) {
    var full_screen_enabled = 0;
    var element = jQuery("#viewerExpiviContainer").get(0);
    if (element.requestFullScreen) {
      full_screen_enabled = 1;
    } else if (element.webkitRequestFullScreen) {
      full_screen_enabled = 1;
    } else if (element.mozRequestFullScreen) {
      full_screen_enabled = 1;
    } else if (element.msRequestFullscreen) {
      full_screen_enabled = 1;
    } else if (element.webkitEnterFullscreen) {
      full_screen_enabled = 1;
    }
    if (full_screen_enabled == 0) {
      jQuery(".button-fullscreen").hide();
    }
  }

  $(".button-fullscreen").on("click", function () {
    // if already full screen; exit
    // else go fullscreen
    $("body").toggleClass("fullscreen");
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      var full_screen_enabled = 0;
      var element = $("#viewerExpiviContainer").get(0);
      if (element.requestFullScreen) {
        full_screen_enabled = 1;
        element.requestFullScreen();
      } else if (element.webkitRequestFullScreen) {
        full_screen_enabled = 1;
        element.webkitRequestFullScreen();
      } else if (element.mozRequestFullScreen) {
        full_screen_enabled = 1;
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        full_screen_enabled = 1;
        element.msRequestFullscreen();
      } else if (element.webkitEnterFullscreen) {
        full_screen_enabled = 1;
        element.webkitEnterFullscreen(); //for iphone this code worked
      }
      if (full_screen_enabled == 0) {
        $(".button-fullscreen").hide();
      }
    }
  });

  jQuery(".used-products-title").delay(1000).show(10);
  jQuery(".buy-products").delay(1000).css("display", "block");

  jQuery("body").on("mouseover", function () {
    if (jQuery(".expivi-options-wrapper .v-responsive__content").length > 0) {
      var options_wrapper = jQuery("body").find(".expivi-options-wrapper");
      var diff =
        jQuery(window).height() -
        jQuery("#viewerExpiviContainer").offset().top +
        jQuery(window).scrollTop();
      //options_wrapper.css('max-height', 'none');
      var height = options_wrapper
        .find(" > .xpv-app-container > .v-application--wrap > .x-p-v")
        .height();
      if (height > diff || height >= 750) {
        jQuery(".scroll-info").show();
        options_wrapper.removeClass("no-scroll");
      } else {
        options_wrapper.addClass("no-scroll");
      }
      if (diff >= 860) {
        options_wrapper.css("max-height", "860px");
      } else {
        options_wrapper.css("max-height", diff + "px");
      }
      //jQuery('.catalogue-button').html('Add products to scene');
    }
  });

  set_expivi_options_height();

  jQuery(window).on("resize", function () {
    set_expivi_options_height();
  });
  jQuery(window).on("scroll", function () {
    set_expivi_options_height();
  });
  jQuery(".expivi-options-wrapper").on("scroll", function () {
    jQuery(".scroll-info").addClass("hidden");
  });

  jQuery(".r-primary .sign-in-link").on("click", function () {
    jQuery("body").addClass("log-in-opened");
  });

  jQuery(".r-primary .menu-create-account").unbind("click");
  jQuery(".r-primary .menu-create-account").on("click", function () {
    jQuery("#header").removeClass("open");
    jQuery("body").addClass("log-in-opened");
    jQuery('a[data-linklocal="#option-registration-form"] button').click();
  });

  if (jQuery("#user-login-form .form-actions .loading").length == 0) {
    jQuery("#user-login-form .form-actions").prepend(
      '<div class="loading"></div>'
    );
  }
  jQuery("#user-login-form .form-actions .btn").click(function () {
    jQuery("#user-login-form .form-actions .loading").show();
  });

  $(".delete-scene").click(function () {
    $("#colorbox").addClass("add-scene-colorbox");
  });
  $(".button1").click(function () {
    $("#colorbox").removeClass("add-scene-colorbox");
  });

  if (
    window.innerWidth > window.innerHeight ||
    /Windows/i.test(navigator.userAgent) == true
  ) {
    jQuery(
      ".page-ar-scene .popup-portrait-message, .page-ar-scene .blackout-all, .node-type-ar .popup-portrait-message, .node-type-ar .blackout-all"
    ).css("display", "none");
  } else {
    jQuery(
      ".page-ar-scene .popup-portrait-message, .page-ar-scene .blackout-all, .node-type-ar .popup-portrait-message, .node-type-ar .blackout-all"
    ).css("display", "block");
  }
  $(window).on("orientationchange resize", function () {
    if (
      window.innerWidth > window.innerHeight ||
      /Windows/i.test(navigator.userAgent) == true
    ) {
      jQuery(
        ".page-ar-scene .popup-portrait-message, .page-ar-scene .blackout-all, .node-type-ar .popup-portrait-message, .node-type-ar .blackout-all"
      ).css("display", "none");
    } else {
      jQuery(
        ".page-ar-scene .popup-portrait-message, .page-ar-scene .blackout-all, .node-type-ar .popup-portrait-message, .node-type-ar .blackout-all"
      ).css("display", "block");
    }
  });
  $(".blackout-all").on("click", function () {
    jQuery(".popup-portrait-message, .blackout-all").css("display", "none");
  });

  $("a#back_to_top").show();
  check_scroll();

  $(window).scroll(function () {
    check_scroll();
  });

  // scroll body to 0px on click

  $("a#back_to_top").unbind("click");
  $("a#back_to_top").click(function () {
    //$('html, body').scrollTop( 0, 0);

    $("html, body").animate({ scrollTop: 0 }, 50);

    return false;
  });

  //rotate image for switching from portrait to landscape orientation
  setInterval(function () {
    $(".popup-portrait-message").toggleClass("rotate");
  }, 2000);
});

function check_scroll() {
  var scrollTop = 0;
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop;
  }
  if (jQuery(this).scrollTop() > 100 || scrollTop > 100) {
    jQuery("a#back_to_top").fadeIn("fast");
  } else {
    jQuery("a#back_to_top").fadeOut();
  }
}

function copyToClipboardMsg(elem, msgElem) {
  var succeed = copyToClipboard(elem);
  var msg;
  if (!succeed) {
    msg = "Copy not supported or blocked.  Press Ctrl+c to copy.";
  } else {
    msg = "Your sharable link copied.";
  }
  if (typeof msgElem === "string") {
    msgElem = document.getElementById(msgElem);
  }
  msgElem.innerHTML = msg;
  setTimeout(function () {
    msgElem.innerHTML = "";
  }, 4000);
}

function copyToClipboard(elem) {
  // create hidden text element, if it doesn't already exist
  var targetId = "_hiddenCopyText_";
  var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
  var origSelectionStart, origSelectionEnd;
  if (isInput) {
    // can just use the original source element for the selection and copy
    target = elem;
    origSelectionStart = elem.selectionStart;
    origSelectionEnd = elem.selectionEnd;
  } else {
    // must use a temporary form element for the selection and copy
    target = document.getElementById(targetId);
    if (!target) {
      var target = document.createElement("textarea");
      target.style.position = "absolute";
      target.style.left = "-9999px";
      target.style.top = "0";
      target.id = targetId;
      document.body.appendChild(target);
    }
    target.textContent = elem.textContent;
  }
  // select the content
  var currentFocus = document.activeElement;
  target.focus();
  target.setSelectionRange(0, target.value.length);

  // copy the selection
  var succeed;
  try {
    succeed = document.execCommand("copy");
  } catch (e) {
    succeed = false;
  }
  // restore original focus
  if (currentFocus && typeof currentFocus.focus === "function") {
    currentFocus.focus();
  }

  if (isInput) {
    // restore prior selection
    elem.setSelectionRange(origSelectionStart, origSelectionEnd);
  } else {
    // clear temporary content
    target.textContent = "";
  }
  return succeed;
}

function set_expivi_options_height() {
  if (jQuery(".expivi-options-wrapper").length) {
    var diff =
      jQuery(window).height() -
      jQuery("#viewerExpiviContainer").offset().top +
      jQuery(window).scrollTop();
    if (diff >= 860) {
      jQuery(".expivi-options-wrapper").css("max-height", "860px");
    } else {
      jQuery(".expivi-options-wrapper").css("max-height", diff + "px");
    }
  }
}

function onSelected(aProduct) {
  jQuery(
    ".expivi-options-wrapper .v-application .theme--light.v-sheet--outlined.rounded"
  ).removeClass("select-disabled");
  console.log()
  let uid = aProduct ? aProduct.mObjectUUID : expivi.viewer.mSelectedProduct.mObjectUUID;
  if (!uid) {
    productSelect(
      jQuery(
        ".expivi-options-wrapper .v-application .theme--light.v-sheet--outlined.rounded"
      ).eq(0)
    );
  } else {
    jQuery("body")
      .find(".theme--light.v-sheet--outlined.rounded .v-card__title")
      .each(function () {
        let product_uid = jQuery(this)
          .parent()
          .parent()
          .attr("data-product-uuid");
        if (product_uid == uid) {
          productSelect(jQuery(this).parent().parent());
        }
      });
  }
}

function onDeselected() {}

function isRootProductNode(aProductNode) {
  if (!aProductNode) {
    return false;
  }
  const parentProduct =
    typeof aProductNode.findParentOfTypeName === "function"
      ? aProductNode.findParentOfTypeName()
      : undefined;
  return !parentProduct;
}

function resolvedProductNode(aObject) {
  if (!aObject) {
    return undefined;
  }

  if (
    typeof aObject.isDerivedOfTypeName === "function" &&
    aObject.isDerivedOfTypeName("ProductNode")
  ) {
    return aObject;
  }

  const sceneObject = aObject.userData
    ? aObject.userData.sceneObjectRef
    : undefined;
  if (
    sceneObject &&
    typeof sceneObject.isDerivedOfTypeName === "function" &&
    sceneObject.isDerivedOfTypeName("ProductNode")
  ) {
    return sceneObject;
  }

  return resolvedProductNode(
    sceneObject && typeof sceneObject.getParent === "function"
      ? sceneObject.getParent()
      : undefined
  );
}
/*
if ($.cookie(states[url]) == null ) {
    $.cookie(states[url], [], 1);
}
*/
jQuery(".catalogue-button").hide();

if (window.expivi) {
  const queryString = window.location.search || "";
  window.expivi._events.onReady.subscribe(function () {
    if (queryString.indexOf("ar_load") > 0) {
      jQuery("#xpv-toolbar-item-web-ar").click();
    }
  });

  window.expivi._events.onChange.subscribe(
    function (aEvent) {
      if (aEvent.name == "detached") {
        //remove product
        jQuery(".expivi-options-wrapper")
          .find(" .x-p-v>.container>div>div:last-child")
          .hide();
      }

      if (aEvent.name == "selected") {
        // onSelected(window.expivi.viewer.mSelectedProduct);
        const selection = aEvent.payload.getData().selection;
        if (!selection) {
          onDeselected();
          return;
        }

        const object = resolvedProductNode(selection);
        if (object) {
          if (selection.type == "Group" || selection.type == "Mesh") {
            onSelected(object);
          }
        } else {
          onDeselected();
        }
      }
      if (
        aEvent.name == "product_finished_loading" &&
        window.expivi.viewer.mSelectedProduct
      ) {
        onSelected(window.expivi.viewer.mSelectedProduct);
      }
      if (
        aEvent.name == "fully_loaded" &&
        (jQuery("body").hasClass("page-ar-scene") ||
          jQuery("body").hasClass("page-ar-scenes"))
      ) {
        sceneFullyLoadedOccurred = true;
      }
    },
    function (ex) {
      console.error(ex);
    }
  );
}

var productSelect = function (el) {
  // setInterval(function () {
  jQuery("body").removeClass("clicked-product");
  // }, 2000); //disable click for 2 seconds after click
  if (jQuery("body").hasClass("catalog-opened")) {
    jQuery(".catalogue-button").click();
  }

  //   if (!jQuery('body').hasClass('clicked-product')) {
  jQuery("body").removeClass("more-products").removeClass("first-load");
  var parent = el.parent().parent();

  parent.siblings().find(".v-sheet--outlined.rounded").removeClass("opened");
  el.addClass("opened");
  parent.css({ position: "relative", bottom: "auto" });
  parent.siblings().css({ position: "relative", bottom: "auto" });
  jQuery(
    ".expivi-options-wrapper .xpv-app-container>.v-application--wrap .x-p-v>.container>.overflow-x-hidden"
  ).css("padding-bottom", "0");

  var siblings = el.parent().parent().nextAll();
  if (siblings.length) {
    siblings.css("position", "absolute");
    var bottom_offset = 1;
    var padding_parent = 0;
    siblings.reverse(function (i, e) {
      if (i + 1 !== siblings.length) {
        bottom_offset += el.height() + 10;
      }
      padding_parent += el.height() + 10;
      jQuery(this).css("bottom", bottom_offset + "px");
    });
    siblings
      .parent()
      .parent()
      .css("padding-bottom", padding_parent + "px");
  }
  jQuery(".expivi-options-wrapper .x-p-v>.container>div>div:last-child")
    .delay(500)
    .css("display", "block");

  jQuery("body").addClass("clicked-product");
  //   }
};

/* =================================================================
 *  Keep focus on auto-submitted text-fields without surrounding block
 *  ============================================================== */

function SetCaretAtEnd(elem) {
  var elemLen = elem.value.length;
  // For IE Only
  if (document.selection) {
    // Set focus
    elem.focus();
    // Use IE Ranges
    var oSel = document.selection.createRange();
    // Reset position to 0 & then set at end
    oSel.moveStart("character", -elemLen);
    oSel.moveStart("character", elemLen);
    oSel.moveEnd("character", 0);
    oSel.select();
  } else if (elem.selectionStart || elem.selectionStart == "0") {
    // Firefox/Chrome
    elem.selectionStart = elemLen;
    elem.selectionEnd = elemLen;
    elem.focus();
  } // if
} // SetCaretAtEnd()

var textboxToFocus = {};

jQuery(function ($) {
  var addFocusReminder = function (textbox) {
    textbox.bind("keypress keyup", function (e) {
      textboxToFocus.formid = $(this).closest("form").attr("id");
      textboxToFocus.name = $(this).attr("name");

      if (e.type == "keypress") {
        if (e.keyCode != 8) {
          // everything except return
          textboxToFocus.value =
            $(this).val() + String.fromCharCode(e.charCode);
        } else {
          textboxToFocus.value = $(this)
            .val()
            .substr(0, $(this).val().length - 1);
        }
      } else {
        // keyup
        textboxToFocus.value = $(this).val();
      }
    });
  };

  addFocusReminder(
    $(".views-exposed-form input:text.ctools-auto-submit-processed")
  );
  $(document).ajaxComplete(function (event, request, settings) {
    if (typeof textboxToFocus.formid !== "undefined") {
      var textBox = $(
        "#" +
          textboxToFocus.formid +
          ' input:text[name="' +
          textboxToFocus.name +
          '"]'
      );
      textBox.val(textboxToFocus.value);
      SetCaretAtEnd(textBox[0]);
      addFocusReminder(textBox);
      //textboxToFocus = {}; // if you have other auto-submitted inputs as well
    }
  });
});

var waitForEl = function (selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function () {
      waitForEl(selector, callback);
    }, 100);
  }
};

function onElementInserted(containerSelector, elementSelector, callback) {
  var onMutationsObserved = function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        var elements = $(mutation.addedNodes).find(elementSelector);
        for (var i = 0, len = elements.length; i < len; i++) {
          callback(elements[i]);
        }
      }
    });
  };

  var target = $(containerSelector)[0];
  var config = { childList: true, subtree: true };
  var MutationObserver =
    window.MutationObserver || window.WebKitMutationObserver;
  var observer = new MutationObserver(onMutationsObserved);
  observer.observe(target, config);
}

async function copyProduct(product_uid) {
  const configuration = await expivi.saveConfiguration(0, 0);
  const products = await configuration.configured_products;
  const originalProduct = products.find(
    (product) => product.uuid === product_uid
  );
  const originalProductAttributes = getProductAttributes(
    products,
    originalProduct
  );
  const productData = await expivi.getCatalogueProductById(
    originalProduct.catalogue_id
  );
  const productName = await productData.name;
  const positionTransformX = productOffsetX(productName);
  // const positionTransformX = randomDoubleFromInterval(7, 15);
  await expivi
    .addProduct(originalProduct.catalogue_id, {
      transform: { position: { x: positionTransformX, y: 0, z: 0 } },
    })
    .then(async (newProductId) => {
      let newConfiguration = await expivi.saveConfiguration(0, 0);
      let newProducts = await newConfiguration.configured_products;
      let newProduct = await newProducts.find(
        (product) => product.uuid === newProductId
      );
      let newProductAttributes = await getProductAttributes(
        products,
        newProduct
      );
      let attributes = await originalProductAttributes.filter(
        (o1) =>
          !newProductAttributes.some(
            (o2) => o1.attribute_value_name === o2.attribute_value_name
          )
      );
      await attributes.forEach((attribute) =>
        expivi.setProductAttributeNamed(
          attribute.attribute_name,
          attribute.attribute_value_name,
          newProductId
        )
      );
    });
}

function createDraggableItem(product, productDataVAttribute) {
  const output = `<div ${productDataVAttribute} data-product="${product.id}" data-title="${product.name}" xs="6" class="draggable-item col-sm-6 col-md-4 col-lg-4 col">
    <div ${productDataVAttribute} class="pa-4 v-card v-sheet v-sheet--outlined theme--light"><div ${productDataVAttribute} class="v-image v-responsive white--text align-end image theme--light">
    <div class="v-responsive__sizer" style="padding-bottom: 79.9424%;">
    </div><div ${productDataVAttribute} class="v-image__image v-image__image--cover" style="background-image: url('${product.thumbnail_url}'); background-position: center center;"></div>
    <!----><div class="v-responsive__content" style="width: 1042px;"></div></div><div ${productDataVAttribute} class="card-text"><div ${productDataVAttribute} class="v-card__title">${product.name}</div><div ${productDataVAttribute} class="v-card__subtitle subtitle">€0.00</div></div></div></div>`;
  return output;
}

function randomDoubleFromInterval(min, max) {
  return (Math.random() * (max - min) + min) / 10.0;
}

function productOffsetX(productName) {
  const largeProducts = [
    "bed",
    "sectional",
    "sofa",
    "table",
    "desk",
    "loveseat",
    "seater",
    "bench",
    "dresser",
    "console",
    "sideboard",
    "rug",
  ];
  let extraOffsetX = 0;
  if (largeProducts.some((v) => productName.toLowerCase().includes(v))) {
    extraOffsetX = 10;
  }
  return randomDoubleFromInterval(7 + extraOffsetX, 15 + extraOffsetX);
}

function getProductAttributes(products, product) {
  let productAttributes;
  if (product.replication_type === "REPLICA" && product.original_uuid) {
    productAttributes = products.find(
      (el) => el.uuid === product.original_uuid
    ).attributes;
  } else {
    productAttributes = product.attributes;
  }
  return productAttributes;
}

function getModalWindow() {
  const output = `<div id="scene-modal-window">
            <div class="popup-icon"></div>
            <hr />
            <h4>AN ERROR OCCURED LOADING THIS PAGE</h4>
            <hr />
            <p>Please refresh the page or try Incognito window to load your saved scene.</p>
            <button style="background: none; padding: 4px 25px; border: 1px solid #333" id="close-modal-window">CLOSE</button>
        </div>
        <div class="blackout-header" style="display: block;"></div>
        `;
  return output;
}

(() => {
  const HIDDEN_CATEGORIES = new Set([
    'Kitchen Cabinets',
    'Tano Outdoor Collection'
  ]);

  function hideCategories() {
    document.querySelectorAll('h2').forEach(h2 => {
      const title = h2.textContent.trim();

      if (HIDDEN_CATEGORIES.has(title)) {
        const row = h2.closest('.row');
        if (row && row.style.display !== 'none') {
          row.style.display = 'none';
        }
      }
    });
  }

  hideCategories();

  const observer = new MutationObserver(() => {
    hideCategories();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
